export default [
    {
        path: '/website-customer-reviews',
        props: true,
        component: () => import('@/views/WebsiteCustomerReview'),
    },
];
